export default __webpack_public_path__ + "static/media/Vector.74c79ade.png";